import axios from "axios";

const normalizeBase = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  return raw.endsWith("/") ? raw : `${raw}/`;
};

const DEFAULT_BASE = "https://hmam.prootech-cloud.com/api/";
const API_BASE = normalizeBase(process.env.REACT_APP_API_URL || DEFAULT_BASE);

const getSettingsEndpoints = () => {
  const list = [API_BASE, DEFAULT_BASE, "http://127.0.0.1:5000/api/"];

  if (typeof window !== "undefined" && window.location?.hostname) {
    list.push(`${window.location.origin}/api/`);
    list.push(`${window.location.protocol}//${window.location.hostname}:5000/api/`);
  }

  return [...new Set(list.map(normalizeBase).filter(Boolean))].map(
    (base) => `${base}settings/`
  );
};

const requestWithFallback = async (factory) => {
  const endpoints = getSettingsEndpoints();
  let lastError = null;

  for (const endpoint of endpoints) {
    try {
      return await factory(endpoint);
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("Settings API unavailable");
};

export const getAllSettingsApi = async () => {
  const response = await requestWithFallback((endpoint) => axios.get(endpoint));

  return {
    data: response?.data || {},
    status: response?.status || 500,
  };
};

export const UpdateSettingsApi = async (requestData) => {
  const token = localStorage.getItem("token");

  const response = await requestWithFallback((endpoint) =>
    axios.put(endpoint, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
  );

  return {
    data: response?.data || {},
    status: response?.status || 500,
  };
};
